import usaCountyJson from '@shared/utils/topojson/regions/US/county/subdivisions.topo.json';
import usaStatesJson from '@shared/utils/topojson/regions/US/state/subdivisions.topo.json';
import chinaCountyJson from '@shared/utils/topojson/regions/CN/county/subdivisions.topo.json';
import chinaPrefectureJson from '@shared/utils/topojson/regions/CN/prefecture/subdivisions.topo.json';
import chinaProvinceJson from '@shared/utils/topojson/regions/CN/province/subdivisions.topo.json';
import europeJson from '@shared/utils/topojson/regions/EU/subdivisions.topo.json';
import asiaPacificJson from '@shared/utils/topojson/regions/APAC/subdivisions.topo.json';
import asiaJson from '@shared/utils/topojson/regions/ASEAN/subdivisions.topo.json';
import japanPrefectureJson from '@shared/utils/topojson/regions/JP/prefecture/subdivisions.topo.json';
import southKoreaJson from '@shared/utils/topojson/regions/KR/province/subdivisions.topo.json';
import indiaJson from '@shared/utils/topojson/regions/IN/state/subdivisions.topo.json';
import australiaJson from '@shared/utils/topojson/regions/AU/state/subdivisions.topo.json';
import taiwanJson from '@shared/utils/topojson/regions/TW/county/subdivisions.topo.json';
import pacificJson from '@shared/utils/topojson/regions/PI/subdivisions.topo.json'

export const USA_COUNTY = 'us_county';
export const USA_STATE = 'us_state';
export const CHINA_COUNTY = 'ch_county';
export const CHINA_PREFECTURE = 'ch_prefecture';
export const CHINA_PROVINCE = 'ch_province';
export const EUROPE = 'eu';
export const ASIA = 'asia';
export const ASIA_PACIFIC = 'asia_pacific';
export const PACIFIC = 'pacific';
export const JAPAN = 'japan';
export const SOUTH_KOREA = 'korea';
export const AUSTRALIA = 'australia';
export const INDIA = 'india';
export const TAIWAN = 'taiwan';

export const REGIONS_LIST = [
  USA_COUNTY,
  USA_STATE,
  CHINA_COUNTY,
  CHINA_PREFECTURE,
  CHINA_PROVINCE,
  EUROPE,
  ASIA,
  ASIA_PACIFIC,
  PACIFIC,
  JAPAN,
  SOUTH_KOREA,
  AUSTRALIA,
  INDIA,
  TAIWAN,
];

export const REGIONS_TRANSLATIONS = {
  [USA_COUNTY]: 'United States - Counties',
  [USA_STATE]: 'United States - States',
  [CHINA_COUNTY]: 'China - Counties',
  [CHINA_PREFECTURE]: 'China - Prefectures',
  [CHINA_PROVINCE]: 'China - Provinces',
  [EUROPE]: 'Europe',
  [ASIA]: 'Asia',
  [ASIA_PACIFIC]: 'Asia Pacific',
  [PACIFIC]: 'Pacific',
  [JAPAN]: 'Japan',
  [SOUTH_KOREA]: 'South Korea',
  [AUSTRALIA]: 'Australia',
  [INDIA]: 'India',
  [TAIWAN]: 'Taiwan',
};

export const REGIONS_DATA = region =>
({
  [USA_COUNTY]: {
    data: usaCountyJson,
  },
  [USA_STATE]: {
    data: usaStatesJson,
  },
  [CHINA_COUNTY]: {
    data: chinaCountyJson,
  },
  [CHINA_PREFECTURE]: {
    data: chinaPrefectureJson,
  },
  [CHINA_PROVINCE]: {
    data: chinaProvinceJson,
  },
  [EUROPE]: {
    data: europeJson,
  },
  [ASIA]: {
    data: asiaJson,
  },
  [ASIA_PACIFIC]: {
    data: asiaPacificJson,
  },
  [PACIFIC]: {
    data: pacificJson,
  },
  [JAPAN]: {
    data: japanPrefectureJson,
  },
  [SOUTH_KOREA]: {
    data: southKoreaJson,
  },
  [AUSTRALIA]: {
    data: australiaJson,
  },
  [INDIA]: {
    data: indiaJson,
  },
  [TAIWAN]: {
    data: taiwanJson,
  },
}[region]);

export const DEFAULT_SIZE = {
  height: 960,
  width: 960,
};

export const REGIONS_SIZE = {
  [ASIA_PACIFIC]: {
    height: 960,
    width: 830,
  },
  [PACIFIC]: {
    height: 800,
    width: 830
  },
  [AUSTRALIA]: DEFAULT_SIZE,
  [CHINA_PROVINCE]: DEFAULT_SIZE,
  [INDIA]: DEFAULT_SIZE,
  [JAPAN]: DEFAULT_SIZE,
  [SOUTH_KOREA]: DEFAULT_SIZE,
  [TAIWAN]: DEFAULT_SIZE,
  [USA_STATE]: {
    height: 960,
    width: 500,
  },
};
